<template>
    <div class="tab-pane fade show active text-center" v-if="!is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="tab-pane fade show active text-center" v-else-if="standings.length == 0">
        <p>No standing data found.</p>
    </div>
    <div class="tab-pane fade show active" v-else>
        <div class="table-responsive" v-for="(group_standing,key) in group_standings">
            <div class="match-table text-white custom-tb">
                <div class="thead">
                    <div class="table-row">
                        <div class="th"># team {{ Object.keys(group_standings).length > 1 ? '('+key+')' : '' }}</div>
                        <div class="th">M</div>
                        <div class="th">W</div>
                        <div class="th">D</div>
                        <div class="th">N/R</div>
                        <div class="th">L</div>
                        <div class="th">NRR</div>
                        <div class="th">pts</div>
                    </div>
                </div>
                <div class="table-body">
                    <div class="tbody">
                        <div class="table-row" :class="{highlight: standing.team_id==global.Components['teamDetail'].team.id}" v-for="standing in group_standing.items" :key="standing.id">
                            <div class="td">
                                <span class="title">{{ standing.position }}. {{ standing.team_name }}</span>
                            </div>
                            <div class="td">{{ standing.matches || 0 }}</div>
                            <div class="td">{{ standing.won || 0 }}</div>
                            <div class="td">{{ standing.tied || 0 }}</div>
                            <div class="td">{{ standing.no_results || 0 }}</div>
                            <div class="td">{{ standing.lost || 0 }}</div>
                            <div class="td">{{ standing.net_RR || '-' }}</div>
                            <div class="td">{{ standing.points || 0 }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import collect from 'collect.js';
    export default {
        name: 'teamStandings',

        data() {
            return {
                standings: []
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        mounted() {
            this.main();
        },
        methods: {
            main() {
                return this.$axios
                        .get(this.$TOURNAMENT_STANDINGS_API.replace(':tournament', this.$route.params.tournament))
                        .then(response => {
                            this.is_data_ready = true
                            this.standings = response.data.result.standings || []
                        })
                        .catch(error => {
                            console.log(error);
                            this.is_data_ready = true
                        })
            }
        },
        computed: {
            group_standings() {
                return collect(this.standings).groupBy('group').sortKeys().all();
            }
        }
    }
</script>

